import { qportalApi } from './qportal-api';
const getHourTypes = () => qportalApi.get('hour-types');
const updateHourTypeDisplayName = (id, request) => qportalApi.patch(`admin/hour-routing/hour-types/${id}/display-name`, request);
const getInternalDepartments = () => qportalApi.get('admin/hour-routing/internal-departments');
const updateInternalDepartment = (id, request) => qportalApi.put(`admin/hour-routing/internal-departments/${id}`, request);
const getProjectTaskMappings = ({ targetType, targetId }) => qportalApi.get('admin/hour-routing/project-task-mappings', {
    params: { targetType, targetId }
});
const createProjectTaskMapping = (request) => qportalApi.post('admin/hour-routing/project-task-mappings', request);
const getInternalDepartmentMemberships = (freelancerId) => qportalApi.get('admin/hour-routing/memberships', { params: { freelancerId } });
const getInternalBookingPermissions = (freelancerId) => qportalApi.get('admin/hour-routing/internal-booking-permissions', { params: { freelancerId } });
const createInternalBookingPermission = (request) => qportalApi.post('admin/hour-routing/internal-booking-permissions', request);
const endInternalBookingPermission = (id, request) => qportalApi.patch(`admin/hour-routing/internal-booking-permissions/${id}/end`, request);
const HourRoutingApi = {
    getHourTypes,
    updateHourTypeDisplayName,
    getInternalDepartments,
    updateInternalDepartment,
    getProjectTaskMappings,
    createProjectTaskMapping,
    getInternalDepartmentMemberships,
    getInternalBookingPermissions,
    createInternalBookingPermission,
    endInternalBookingPermission
};
export default HourRoutingApi;
